import Swiper, { Navigation, Autoplay, Pagination } from "swiper";
import "swiper/css";
Swiper.use([Navigation, Pagination, Autoplay]);

export default class Slider {
  constructor() {
    this.init();
  }

  init() {
    const swiperHero = new Swiper(".p-top__slider", {
      modules: [Navigation, Pagination],
      autoplay: true,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.1,
        },
      },
    });
    const swiperGallery = new Swiper(".p-top__gallery__slide", {
      modules: [Navigation, Pagination],
      autoplay: false,
      loop: true,
      slidesPerView: 1.5,
      spaceBetween: 16,
      centeredSlides: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 4.5,
          centeredSlides: true,
        },
      },
    });
    const swiperNews = new Swiper(".p-top__news__slide", {
      modules: [Navigation, Pagination],
      autoplay: false,
      loop: true,
      slidesPerView: 2,
      spaceBetween: 16,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 4.5,
          centeredSlides: true,
        },
      },
    });
  }
}
